import styled from "styled-components";
import { Footer } from "../../navigation/footer/Footer";
import { PageHeader } from "../../navigation/page-header";
import { LoginAndRegistrationMainContainer } from "./components/LoginAndRegistrationMainContainer";

export function Signup() {
  return (
    <AuthPageShell>
      <PageHeader variant="homepage" />
      <LoginAndRegistrationMainContainer />
      <Footer />
    </AuthPageShell>
  );
}

const AuthPageShell = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: #ffffff;

  > :nth-child(2) {
    flex: 1;
    display: flex;
  }
`;
